class HrDashboardController implements ng.IComponentController {

    constructor() {
        'ngInject';
    }

}

export const hrDashboardComponent: ng.IComponentOptions = {
    controller: HrDashboardController,
    template: require('./hr.dashboard.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/hr/hr.dashboard.component.ts